/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * ########################################
 * Global Ligthbox Options
 * ########################################
 */
import lightbox from 'lightbox2/dist/js/lightbox';

jQuery(document).ready(function($) {

    lightbox.option({
        alwaysShowNavOnTouchDevices: true,
        albumLabel: "Bild %1 von %2",
        disableScrolling: true,
        fadeDuration: 500,
        fitImagesInViewport: true,
        imageFadeDuration: 300,
        resizeDuration: 300,
        showImageNumberLabel: true,
        wrapAround: true,
        positionFromTop: 150,
    });

    $('#lightboxOverlay').detach().appendTo('#site-footer');
    $('#lightbox').detach().appendTo('#site-footer');

});

